import axios from '@/plugins/axios'

export default {
    namespaced: true,
    state: {
        contacts: [],
        loading: false,
        loaded: false,
    },
    mutations: {
        setContacts(state, items) {
            state.contacts = items;
        },
        setLoading(state, value) {
            state.loading = value;
        },
        setLoaded(state, value) {
            state.loaded = value;
        },
    },
    actions: {
        async fetchContacts({ state, commit }) {
            if (state.loaded) {
                return state.contacts;
            }

            commit("setLoading", true);
            try {
                const response = await axios.get('/v3/agreements/contributors/contacts');
                const contacts = response.data || [];
                commit("setContacts", contacts);
                commit("setLoaded", true);
                return contacts;
            } catch (error) {
                commit("setContacts", []);
                commit("setLoaded", false);
                throw error;
            } finally {
                commit("setLoading", false);
            }
        },
    },
};
